<template lang="pug">
  leadsplus-layout
    v-flex(xs12)
      v-container.pa-0(fluid)
        v-layout(row wrap)
          iframe.embedded-component-full(:src="embedComponent" ref="iframe" id="iframe")
</template>

<script>
import LeadsplusLayout from '@/Leadsplus/Layout';
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapBoostActions, mapState: mapBoostState } = createNamespacedHelpers('boost');
export default {
  components: {
    LeadsplusLayout,
  },
  data() {
    return {
      embedComponent: '',
    };
  },
  computed: {
    ...mapBoostState(['boostURL']),
  },
  methods: {
    ...mapBoostActions(['fetchBoostRedirectURL']),
    async getUrl() {
      await this.fetchBoostRedirectURL('account-management');
      this.embedComponent = this.boostURL;
    },
  },
  async mounted() {
    await this.getUrl();
  },
};
</script>

<style lang="scss" scoped>
.embedded-component-full {
  width: 100%;
  border: none;
  min-height: 100vh;
}
</style>
